import { baseService } from "@/services/BaseService";
import { chargingStationModelService } from "@/services/ChargingStationModelService";
import { chargingStationService } from "@/services/ChargingStationService";
import { technicianService } from "@/services/TechnicianService";
import { manufacturerService } from "@/services/ManufacturerService";
import { mapService } from "@/services/MapService";
import { orderService } from "@/services/OrderService";
import { routePointsService } from "@/services/RoutePointsService";
import { routeService } from "@/services/RouteService";
import { serviceVehicleService } from "@/services/ServiceVehicleService";
import { workShiftsService } from "@/services/WorkShiftsService";
import { makeAutoObservable } from "mobx";
import { TechnicianLocationObserver } from "../observers/TechnicianLocationObserver";
import { AuthStore } from "./AuthStore";
import { BasesStore } from "./BasesStore";
import { ChargingStationModelsStore } from "./ChargingStationModelsStore";
import { ChargingStationsStore } from "./ChargingStationsStore";
import { ManufacturersStore } from "./ManufacturersStore";
import { MapStore } from "./MapStore";
import { RefactoredOrderStore } from "./RefactoredOrderStore";
import { RouteListStore } from "./RouteListStore";
import { ServiceVehiclesStore } from "./ServiceVehiclesStore";
import { SingleBaseStore } from "./SingleBaseStore";
import { SingleChargingStationModelStore } from "./SingleChargingStationModelStore";
import { SingleChargingStationStore } from "./SingleChargingStationStore";
import { SingleManufacturerStore } from "./SingleManufacturerStore";
import { SingleRouteStore2 } from "./SingleRouteStore2";
import { SingleServiceVehicleStore } from "./SingleServiceVehicleStore";
import { SingleOrderStore } from "./SingleOrderStore";
import { SingleTechnicianStore } from "./SingleTechnicianStore";
import { SingleWorkShiftStore } from "../pages/WorkShifts/SingleWorkShiftStore";
import { RouteBuilderStore } from "@/components/RouteBuilder/RouteBuilderStore";
import { routeCalculationService } from "@/services/RouteCalculationService";
import { TechniciansStore } from "./TechniciansStore";
import { WorkShiftsStore } from "../pages/WorkShifts/WorkShiftsStore";
import { clientService } from "@/services/ClientService";
import { tariffService } from "@/services/TariffService";
import { VehicleManufacturersStore } from "./VehicleManufacturersStore";
import { SingleVehicleManufacturerStore } from "./SingleVehicleManufacturerStore";
import { vehicleManufacturerService } from "@/services/VehicleManufacturerService";
import { VehicleModelsStore } from "./VehicleModelsStore";
import { SingleVehicleModelStore } from "./SingleVehicleModelStore";
import { vehicleModelService } from "@/services/VehicleModelService";
import { ChatStore } from "./ChatStore";
import { DashboardStore } from "./DashboardStore";
import { TariffsStore } from "./TariffsStore";
import { SingleTariffStore } from "./SingleTariffStore";
import { OrderDetailStore } from "./OrderDetailStore";
import { orderDetailsService } from "@/services/OrderDetailsService";
import { companyService } from "@/services/CompanyService";
import { companyLinkService } from "@/services/CompanyLinkService";
import { corpAdminService } from "@/services/CorpAdminService";
import { companyFinanceService } from "@/services/CompanyFinanceService";
import { companySettlementsService } from "@/services/CompanySettlementsService";
import { companyReportService } from "@/services/CompanyReportService";
import { CompaniesStore } from "./CompaniesStore";
import { SingleCompanyStore } from "./SingleCompanyStore";
import { CompanyLinksStore } from "./CompanyLinksStore";
import { CorpAdminsStore } from "./CorpAdminsStore";
import { CompanySettlementsStore } from "./CompanySettlementsStore";
import { CompanyReportStore } from "./CompanyReportStore";
export class RootStore {
    constructor() {
        this.authStore = new AuthStore();
        this.manufacturersStore = new ManufacturersStore(manufacturerService);
        this.chargingStationModelsStore = new ChargingStationModelsStore(chargingStationModelService);
        this.chargingStationsStore = new ChargingStationsStore(chargingStationService);
        this.serviceVehiclesStore = new ServiceVehiclesStore(serviceVehicleService);
        this.basesStore = new BasesStore(baseService);
        this.vehicleManufacturersStore = new VehicleManufacturersStore(vehicleManufacturerService);
        this.vehicleModelsStore = new VehicleModelsStore(vehicleModelService);
        this.singleBaseStore = new SingleBaseStore(baseService);
        this.singleChargingStationModelStore = new SingleChargingStationModelStore(chargingStationModelService, manufacturerService);
        this.singleChargingStationStore = new SingleChargingStationStore(chargingStationService, chargingStationModelService);
        this.singleManufacturerStore = new SingleManufacturerStore(manufacturerService);
        this.singleServiceVehicleStore = new SingleServiceVehicleStore(serviceVehicleService);
        this.singleOrderStore = new SingleOrderStore(orderService, clientService, tariffService, technicianService);
        this.singleTechnicianStore = new SingleTechnicianStore(technicianService);
        this.singleWorkShiftStore = new SingleWorkShiftStore(workShiftsService, technicianService);
        this.singleVehicleManufacturerStore = new SingleVehicleManufacturerStore(vehicleManufacturerService);
        this.singleVehicleModelStore = new SingleVehicleModelStore(vehicleModelService, vehicleManufacturerService);
        this.orderStore = new RefactoredOrderStore(orderService);
        this.routeListStore = new RouteListStore(routeService);
        this.techniciansStore = new TechniciansStore(technicianService);
        this.workShiftsStore = new WorkShiftsStore(workShiftsService, technicianService);
        const routeBuilderStore = new RouteBuilderStore(baseService, routeService, routePointsService, routeCalculationService);
        this.singleRouteStore2 = new SingleRouteStore2(routeService, routePointsService, technicianService, serviceVehicleService, chargingStationService, workShiftsService, routeBuilderStore);
        this.mapStore = new MapStore(mapService);
        this.technicianLocationObserver = new TechnicianLocationObserver(mapService);
        this.chatStore = new ChatStore();
        this.dashboardStore = new DashboardStore();
        this.tariffsStore = new TariffsStore(tariffService);
        this.singleTariffStore = new SingleTariffStore(tariffService);
        this.orderDetailStore = new OrderDetailStore(orderDetailsService);
        this.companiesStore = new CompaniesStore(companyService);
        this.singleCompanyStore = new SingleCompanyStore(companyService, companyFinanceService);
        this.companyLinksStore = new CompanyLinksStore(companyLinkService);
        this.clientCompaniesStore = new CompanyLinksStore(companyLinkService);
        this.corpAdminsStore = new CorpAdminsStore(corpAdminService);
        this.companySettlementsStore = new CompanySettlementsStore(companySettlementsService, this.singleCompanyStore);
        this.companyReportStore = new CompanyReportStore(companyReportService);
        makeAutoObservable(this);
    }
}
const rootStoreInstance = new RootStore();
export const getRootStore = () => {
    return rootStoreInstance;
};
